import modalTemplate from './view.html';
import { ReportModalController } from './controller';

import { REPORT_MODAL_CONTROLLER } from '../../const';

class ReportModal {
    constructor($uibModal) {
        'ngInject';
        this.$uibModal = $uibModal;
        this.modalInstance = null;
    }

    $onInit = () => {
        this.$uibModal;
    };

    open = (params = null) => {
        this.modalInstance = this.$uibModal.open({
            template: modalTemplate,
            bindToController: true,
            controller: REPORT_MODAL_CONTROLLER,
            controllerAs: '$',
            size: 'lg',
            resolve: {
                params: params,
            },
            backdrop: 'static',
            keyboard: false,
        });

        return this.modalInstance.result;
    };
}

export {
    ReportModal,
    ReportModalController,
};
